import React, { useState, useMemo, useCallback } from "react"

import { useFunctions } from "../../hooks/useFunctions"
import { useSettings } from "../../hooks/useSettings"
import { useCore } from "../../hooks/useCore"

export const withSubscribeFooter = Component =>
  React.memo(({ name = "Subscribe" }) => {
    const {
      helpers: { sanityContent },
    } = useCore()
    const { subscribeFooter } = useSettings()
    const { customerSubscribe, errors, loading } = useFunctions()
    const [data, setData] = useState({ email: "" })
    const [success, setSuccess] = useState(false)

    const handleSubmit = useCallback(async event => {
      event.preventDefault()
      const { customer } = await customerSubscribe(data?.email)
      if (customer?.id) {
        setSuccess(true)
      }
      //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleChange = useCallback(({ target: { name, value } }) => {
      setData(prevState => ({
        ...prevState,
        [name]: value,
      }))
      //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const title = subscribeFooter?.footerTitle
    const description = sanityContent(subscribeFooter?.footerContent)
    const successMessage = sanityContent(subscribeFooter?.footerSuccessMessage)

    Component.displayName = name
    return useMemo(
      () => (
        <Component
          data={data}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          errors={errors}
          title={title}
          description={description}
          successMessage={successMessage}
          success={success}
          loading={loading}
        />
      ),
      [data, errors, success, loading, title, description, successMessage, handleChange, handleSubmit]
    )
  })
